var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ImageTitle flex flex-column"},[_c('span',{staticClass:"zh fw-n"},[_vm._v(_vm._s(_vm.Zh))]),_vm._v(" "),_c('span',{staticClass:"en fw-n"},[_vm._v(_vm._s(_vm.En))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077e0b3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageTitle.vue
// module id = 0Boa
// module chunks = 1